import { deactivateAIAssistant } from 'apis/Payment/Subscription';
import { useAppStore } from 'hooks/useAppStore';
import moment from 'moment';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ErrorResponse } from 'types';
import { fetchServerError } from 'utils';

export const useDeactivateAIAssistant = () => {
  const queryClient = useQueryClient();
  const {
    subscriptionStore: { currentSubscription, updateCurrentSubscription },
    workspaceStore: { currentWorkspaceId },
  } = useAppStore();

  return useMutation(deactivateAIAssistant, {
    onSuccess: () => {
      const subscriptionEndsAt = moment(currentSubscription?.currentPeriodEnd).format('LL');
      updateCurrentSubscription({ ...currentSubscription, cancelAIAssistantAtPeriodEnd: true });
      toast.success(`Michi Assistant will be deactivated on ${subscriptionEndsAt}`);
      queryClient.invalidateQueries(['workspaces', currentWorkspaceId, 'usage-record']);
    },
    onError: (error: ErrorResponse) => {
      toast(fetchServerError(error), { type: 'error' });
    },
  });
};
